import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';

const Auth = ({children}) => {
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const navigate = useNavigate();
    const [loading,setLoading]=useState(true);

    useEffect(() => {
        console.log(userDetails);
       if (!userDetails?.token) {
            navigate("/sub");
        }
        else{
            setLoading(false);
        }
    }, []);
    return (
        <>
        { !loading && children }
        </>
    )
}

export default Auth